module.exports = __webpack_public_path__ + "img/fork.034acba3.png";